import React from 'react'

function Loading () {
  const array = [1,2,3,4,5,6,7,8]

  const img_loading = () => {
    return (array.map(() => 
        <Imgloading/>
    ))
  }

  return (
    <div className="loading">
      {
        img_loading()
      }
    </div>
  )
}

export default Loading



const Imgloading: React.FC = () => {
  return(
    <div className="img">
      <img src="https://yoose.com/hubfs/y-case-study/assets/images/Screenshot_loading.gif" alt=""/>
    </div>
  )
}